
export default ({
  treatment,
  first_name: firstName,
  last_name: lastName,
  mothers_last_name: secondLastName
}) => {
  return `${treatment !== null ? treatment : ''} ${firstName} ${lastName || ''} ${secondLastName || ''}`.trim()
}
